import parsePhoneNumber, { AsYouType } from 'libphonenumber-js';

import moment from 'moment';

export const TIMEZONE_LIST = {
  'America/Chicago': 'CT',
  'America/Denver': 'MT',
  'America/Los_Angeles': 'PT',
  'America/New_York': 'ET',
};

export const formatDate = (date, format = 'MM/DD/YYYY') => {
  if (!date) return '--';
  return moment(date.split('[UTC]')[0]).format(format);
};

export const formatDateToLocalTime = (dateUtc, format = 'MM/DD/YYYY') => {
  if (!dateUtc) return '--';
  const utcTime = dateUtc.split('[UTC]')[0];
  const offset = moment().utcOffset();
  const localText = moment.utc(utcTime).utcOffset(offset).format(format);
  return localText;
};

export const formatName = (name) => {
  if (!name) return;
  const normalize = (str) => str[0].toUpperCase() + str.slice(1);
  name = name.toLowerCase().split(' ');
  return name.map((n) => normalize(n)).join(' ');
};

export const formatPhoneNumber = (str) => {
  //Filter only numbers from the input
  let cleaned = ('' + str).replace(/\D/g, '');

  //Check if the input is of correct
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    //Remove the matched extension code
    //Change this to format for any country code.
    let intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }

  return null;
};

export const isPhoneNumber = (val) => {
  let type = val.toLowerCase();
  return type.indexOf('email') < 0;
};

export const libphonenumberFormat = (value) => {
  if (!value) return '';
  value = value.toString();
  if (value.includes('(') && !value.includes(')')) {
    return value.replace('(', '');
  }
  return new AsYouType('US').input(value);
};

export const formatToNationalPhone = (value) => {
  if (!value) return '';
  const phoneNumber = parsePhoneNumber(value + '', 'US');
  if (phoneNumber) return phoneNumber.formatNational();
  else return new AsYouType('US').input(value);
};

const getNumberOnly = (str) => ('' + str).replace(/\D/g, '');

export const getRawPhoneNumber = (str) => {
  if (str)
    return (
      parsePhoneNumber(str || '', 'US')?.number?.toString() ||
      getNumberOnly(str)
    );
  return getNumberOnly(str);
};

export const formatDateWithTz = (
  date,
  timeZone = 'America/New_York',
  locale = 'en-US'
) => {
  if (!date) {
    return '\u2014';
  }
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: timeZone,
  }).format(moment(date.split('[UTC]')[0]).toDate());
};

export const formatTimeWithTz = (
  date,
  timeZone = 'America/New_York',
  locale = 'en-US'
) => {
  if (!date) {
    return '\u2014';
  }
  return new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: timeZone,
  }).format(moment(date.split('[UTC]')[0]).toDate());
};

export const formatTimeWithCurrentTz = (date) => {
  if (!date) {
    return '\u2014';
  }
  const timeZone = getCurrentTz();
  return `${formatTimeWithTz(date, timeZone)} ${TIMEZONE_LIST[timeZone]}`;
};

export const formatDateWithCurrentTz = (date) => {
  if (!date) {
    return '\u2014';
  }
  const timeZone = getCurrentTz();
  return formatDateWithTz(date, timeZone);
};

export const getCurrentTz = () => {
  const currentTz =
    new URLSearchParams(window.location.search).get('tz') ||
    Intl.DateTimeFormat().resolvedOptions().timeZone;
  return TIMEZONE_LIST[currentTz] ? currentTz : 'America/New_York';
};

export const getRawMail = (str) => {
  return str?.toString()?.toLowerCase();
};


// export const formatDateTimeStamp = (isoString) => {
//   try {  
//   const date = new Date(isoString);
//     const options = {
//       timeZone: 'America/New_York',
//       year: 'numeric',
//       month: '2-digit',
//       day: '2-digit',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true
//     };
//     return new Intl.DateTimeFormat('en-US', options).format(date) + ' ET';
//   } catch {
//     return '';
//   }
 
//   }; 

export const formatDateTimeStamp = (isoString) => {
  try {
    const date = new Date(isoString);
    const options = {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };

    // Need to split the date into parts to comply to nonstandard specification
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(date).reduce((acc, part) => {
      if (part.type !== 'literal') {
        acc[part.type] = part.value;
      }
      return acc;
    }, {});

    // Remove the leading zero from the hour if it exists
    const hourFormatted = parts.hour.startsWith('0') ? parts.hour.slice(1) : parts.hour;
    //const monthFormatted = parts.month.startsWith('0') ? parts.month.slice(1) : parts.month;
    //const dayFormatted = parts.day.startsWith('0') ? parts.day.slice(1) : parts.day;

    return `${parts.month}/${parts.day}/${parts.year} ${hourFormatted}:${parts.minute} ${parts.dayPeriod} ET`;
  } catch {
    return '';
  }
};




